import React, { useState } from 'react';
import FormSection from '../../../Elements/FormSection';

function FormSectionDemoComponent() {
  const [purchaseOrder, setPurchaseOrder] = useState('');
  const [invoiceForm, setInvoiceForm] = useState('Detailed US');

  return (
    <div style={{ maxWidth: 640 }}>
      <FormSection
        iconName='fa-solid fa-file-invoice'
        title='Invoice'
        hint='printed on every draft'
      >
        <div className='fsec-fields'>
          <div className='field'>
            <label htmlFor='fsecDemoPo'>Purchase Order #</label>
            <input
              id='fsecDemoPo'
              type='text'
              value={purchaseOrder}
              placeholder='No PO'
              onChange={(e) => setPurchaseOrder(e.target.value)}
            />
          </div>
          <div className='field'>
            <label htmlFor='fsecDemoForm'>Invoice Form *</label>
            <select
              id='fsecDemoForm'
              value={invoiceForm}
              onChange={(e) => setInvoiceForm(e.target.value)}
            >
              <option>Detailed US</option>
              <option>Detailed Belgium</option>
            </select>
          </div>
        </div>
      </FormSection>
      <FormSection
        iconName='fa-solid fa-comment'
        title='Invoice Comments'
      >
        <div className='field'>
          <textarea
            aria-label='Invoice Comments'
            placeholder='Printed on the invoice'
          />
        </div>
        <div className='fsec-note'>A note under the fields.</div>
      </FormSection>
    </div>
  );
}

export const formSectionDemo = {
  id: 'form-section',
  title: 'Form section',
  category: 'Overlays & Editing',
  importPath: 'Elements/FormSection',
  notes: [
    'A section of a form in a window: a head with an icon, a title and a short hint, then the fields.',
    'Fields use the design-system .field (a small capitals label over its input, select or textarea). Several go side by side in a <div className="fsec-fields">, and a small note in a <div className="fsec-note">.',
    'The icon only decorates, so it follows the "I like icons" setting. Sections in a row are spaced apart.',
  ],
  snippet:
    "<FormSection iconName='fa-solid fa-file-invoice' title='Invoice' hint='printed on every draft'>\n  <div className='fsec-fields'>\n    <div className='field'>\n      <label htmlFor='po'>Purchase Order #</label>\n      <input id='po' type='text' />\n    </div>\n  </div>\n</FormSection>",
  render: FormSectionDemoComponent,
};
